<template>
  <div class="wrap login-container">
    <img src="../../assets/images/logo2.png" class="login-icon">
    <div class="login-title">
      <span class="login-title-chinese">研究生学位论文质量送审平台</span>
      <span class="login-title-english">Platform for quality submission of postgraduate Dissertations</span>
    </div>
    <div class="login-image-back"></div>
    <div class="form-data" v-if="curPage==='login'">

      <!-- <div class="logo-title">
        <img width="50" src="../../assets/images/logo-white.png"><span>研究生学位论文质量送审平台</span>
      </div> -->
      <div class="login-box-title">
        <span>用户登录</span>
      </div>
      <div class="change-login">
        <a :class="{'on':loginPage===2}" @click="loginPage=2">短信登录</a>
        <a :class="{'on':loginPage===1}" @click="loginPage=1">账号登录</a>
      </div>
      <Form :model="loginByPwd" label-position="left" :label-width="0" v-show="loginPage===1">
        <FormItem label="" prop="username">
          <Input v-model="loginByPwd.username" ref="username" placeholder="用户名" @keyup.enter.native="handleSubmit">
          </Input>
        </FormItem>
        <FormItem label="" prop="password">
          <Input type="password" ref="password" v-model="loginByPwd.password" placeholder="请输入密码" @keyup.enter.native="handleSubmit"></Input>
        </FormItem>
        <Verify @success="postLogin"
                :mode="'pop'"
                :captchaType="'blockPuzzle'"
                :imgSize="{ width: '330px', height: '155px' }"
                ref="verify"
        ></Verify>
      </Form>
      <Form :model="loginByPhone" label-position="left" :label-width="0" v-show="loginPage===2">
        <FormItem label="" prop="phone">
          <Input v-model="loginByPhone.phone" placeholder="手机号"></Input>
        </FormItem>
        <FormItem label="" prop="code">
          <Input v-model="loginByPhone.code" placeholder="输入验证码" class="send-message">
            <span slot="append" :class="{'disabled': (!formItemRules.isPHONE.test(loginByPhone.phone)||loginByPhone.sending)}" @click="sendMessage">{{loginByPhone.sending?loginByPhone.countDown+'秒':'发送验证码'}}</span>
          </Input>
        </FormItem>
      </Form>
      <div class="change-panel">
        <a @click="switchPage('getpwd')">忘记密码</a>
      </div>
      <div class="oper-panel">
        <button @click="handleSubmit" v-if="loginPage === 1">登录</button>
        <button :class="{'off': !loginVerify}" @click="postLogin" v-if="loginPage === 2">登录</button>
      </div>
    </div>
    <div class="form-data" v-show="curPage==='getpwd'">
      <!-- <label>找回密码</label> -->
      <div class="login-box-title">
        <span>找回密码</span>
      </div>
      <div class="change-panel box-large">
        <a @click="switchPage('login')">返回登录界面</a>
      </div>
      <Form ref="findDataForm" :model="findData" label-position="left" :label-width="0" :rules="findDataValidateRules" @submit.native.prevent>
        <FormItem label="" prop="username" v-if="!findData.validate">
          <Input v-model="findData.username" placeholder="请输入手机号码" @keyup.enter.native="sendMessageForGetPwd"></Input>
        </FormItem>
        <FormItem label="" prop="code" v-if="findData.sending&&!findData.validate">
          <Input v-model="findData.code" placeholder="验证码" @keyup.enter.native="sendMessageForGetPwd"></Input>
        </FormItem>
        <FormItem label="" prop="newPassword" v-if="findData.validate">
          <Input type="password" v-model="findData.newPassword" placeholder="请输入新密码"></Input>
        </FormItem>
        <FormItem label="" prop="comfirmPassword" v-if="findData.validate">
          <Input type="password" v-model="findData.comfirmPassword" placeholder="请输入确认密码" @keyup.enter.native="sendMessageForGetPwd"></Input>
        </FormItem>
      </Form>
      <div class="oper-panel">
        <button :class="{'off': buttonDiasbled}" @click="sendMessageForGetPwd">{{findData.validate?'修改密码':(findData.sending&&!findData.code?findData.countDown+'秒':'下一步')}}</button>
      </div>
      <!-- <p class="register">
        建议您使用Google Chrome、IE11以上版本或360浏览器极速模式以达到最佳展示效果
        <br>
        Copyright © 2019 杭州匡汇科技有限公司 版权所有
        <br>
        <a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备19016117号-1</a>
      </p> -->
    </div>
    <div class="form-data" v-if="curPage==='chooseRole'">
      <label>选择角色</label>
      <div class="role-content" style="display: flex;flex-flow: column;padding: 20px;text-align: center;">
        <Card v-if="roleLoaded && roleList.length > 0" v-for="item in roleList"
              :key="item.roleId"
              @click.native="getRoleMenu(item.roleId, item.roleName)"
              style="cursor: pointer;margin-bottom: 20px;">
          {{item.roleName}}
        </Card>
        <Card v-else-if="roleLoaded">
          当前用户暂无有效角色，请联系管理员。
        </Card>
        <Card v-else>
          角色加载中...
        </Card>
      </div>
      <div class="oper-panel" style="text-align: right;margin-right: 20px;">
        <a @click="loginOut">重新登录</a>
      </div>
    </div>
    <p class="register">
      建议您使用Google Chrome、IE11以上版本或360浏览器极速模式以达到最佳展示效果
      <br>
      Copyright © 2019 杭州匡汇科技有限公司 版权所有
      <br>
      <a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备19016117号-1</a>
    </p>
  </div>
</template>

<script>
/* global FormItemRules:true */
import Verify from '@/components/verifition/Verify'
export default {
  name: 'login',
  components: {
    Verify
  },
  data () {
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.findData.newPassword !== '' && value === '') {
        callback(new Error('确认密码不能为空'));
      } else if (this.findData.newPassword !== value) {
        callback(new Error('两次输入的密码不一致，请重新输入'));
      } else {
        callback();
      }
    }
    return {
      formItemRules: {},
      uuid: '',
      curPage: 'login',
      loginPage: 1,
      loginByPwd: {
        username: '',
        password: '',
        identify: ''
      },
      loginByPhone: {
        phone: '',
        code: '',
        sending: false,
        countDown: 60
      },
      findDataValidateRules: {
        newPassword: [{required: true, message: '新密码不能为空', trigger: 'blur'}],
        comfirmPassword: [{required: true, validator: pwdCheckValidate, trigger: 'blur'}]
      },
      findData: {
        username: '',
        code: '',
        sending: false,
        countDown: 60,
        validate: false,
        newPassword: '',
        comfirmPassword: ''
      },
      timer: null,
      roleLoaded: false,
      roleList: []
    }
  },
  created () {
    const _self = this;
    _self.formItemRules = FormItemRules;
    // 已登录未选择权限
    if (_self.$store.state.user.token) {
      _self.curPage = 'chooseRole';
      _self.getRole();
    }
    // 论文评审链接进入
    if (_self.$route.query.reviewCode) {
      _self.post('/expReviewCodeLogin/loginByReviewCode', {reviewCode: _self.$route.query.reviewCode}).then(res => {
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.token);
          sessionStorage.setItem('menu', JSON.stringify(res.data.menuList));
          sessionStorage.setItem('name', res.data.user.name);
          sessionStorage.setItem('schoolName', res.data.user.schoolName)
          sessionStorage.setItem('balances', res.data.user.balances || '')
          _self.$store.commit('sessionInit');
          _self.$router.push({path: `/shell/custom/expertManage/thesisOnlineReview?id=${res.data.reviewInfo.id}&degreeType=${res.data.paperInfo.degreeType}&unitCode=${res.data.paperInfo.unitCode}`});
        }
      });
    }
  },
  computed: {
    loginVerify () {
      const _self = this;
      return _self.loginByPhone.phone.length > 0 &&
        _self.loginByPhone.code.length > 0;
    },
    buttonDiasbled () {
      const _self = this;
      return (!_self.findData.validate && (!_self.findData.code && (!_self.formItemRules.isPHONE.test(_self.findData.username) || _self.findData.sending))) ||
        (_self.findData.validate && (!(_self.findData.newPassword.length > 0 && _self.findData.newPassword === _self.findData.comfirmPassword)));
    }
  },
  methods: {
    switchPage (page) {
      const _self = this;
      _self.curPage = page;
      if (page === 'login') {
        _self.loginPage = 1;
        _self.loginByPwd = Object.assign(_self.loginByPwd, {
          username: '',
          password: '',
          identify: ''
        });
        _self.loginByPhone = Object.assign(_self.loginByPhone, {
          phone: '',
          code: '',
          sending: false,
          countDown: 60
        });
        if (_self.timer) clearInterval(_self.timer);
      } else {
        _self.findData = {
          username: '',
          code: '',
          sending: false,
          countDown: 60,
          validate: false,
          newPassword: '',
          comfirmPassword: ''
        }
      }
    },
    sendMessage () {
      const _self = this;
      if (!_self.formItemRules.isPHONE.test(_self.loginByPhone.phone)) {
        _self.$Message.warning('请输入有效的电话号码');
      } else if (!_self.loginByPhone.sending) {
        _self.loginByPhone.sending = true;
        _self.loginByPhone.countDown = 60;

        _self.timer = setInterval(function () {
          _self.loginByPhone.countDown = --_self.loginByPhone.countDown;
          if (_self.loginByPhone.countDown <= 0) {
            clearInterval(_self.timer);
            _self.loginByPhone.sending = false;
          }
        }, 1000);

        _self.fetch('/SMSCode', {mobile: _self.loginByPhone.phone}).then(res => {
          _self.$Message.success('发送成功');
        }).catch(error => {
          console.log(error);
          // _self.$Message.error('验证码发送失败，请重新操作');
          // 发送短信请求失败，则初始化让用户重新发送
          if (_self.timer) {
            clearInterval(_self.timer);
          }
          _self.loginByPhone.sending = false;
        });
      } else {
        _self.$Message.info(`短信已发送，请输入验证码，或再${_self.loginByPhone.countDown}秒后重试`);
      }
    },
    sendMessageForGetPwd () {
      const _self = this;
      if (!_self.formItemRules.isPHONE.test(_self.findData.username)) {
        // _self.$Message.warning('请输入有效的电话号码');
      } else if (!_self.findData.sending) {
        // 判断短信发送状态
        _self.findData.sending = true;
        _self.findData.countDown = 60;

        _self.timer = setInterval(function () {
          _self.findData.countDown = --_self.findData.countDown;
          if (_self.findData.countDown <= 0) {
            clearInterval(_self.timer);
            _self.findData.sending = false;
          }
        }, 1000);

        _self.fetch('/SMSCode', {mobile: _self.findData.username}).then(res => {
          _self.$Message.success('验证码已发送');
        }).catch(error => {
          console.log(error);
          _self.$Message.error('验证码发送失败，请重新操作');
          // 发送短信请求失败，则初始化让用户重新发送
          if (_self.timer) {
            clearInterval(_self.timer);
          }
          _self.findData.sending = false;
        });
      } else if (!_self.findData.validate && _self.findData.code) {
        _self.post('/SMSValidate', {
          mobile: _self.findData.username,
          smsCode: _self.findData.code
        }).then(res => {
          _self.findData.validate = true;
          _self.findData.newPassword = '';
          _self.findData.comfirmPassword = '';
          // 清除定时任务
          if (_self.timer) {
            clearInterval(_self.timer);
          }
        });
      } else if (_self.findData.validate) {
        _self.$refs['findDataForm'].validate((valid) => {
          if (valid) {
            _self.post('/resetPassword', {
              mobile: _self.findData.username,
              newPassword: _self.findData.newPassword
            }).then(res => {
              _self.$Message.success('密码修改成功,请使用新密码登录系统。');
              // 页面重载
              _self.$router.go(0);
            });
          }
        });
      } else {
        _self.$Message.info(`短信已发送，请输入验证码，或再${_self.findData.countDown}秒后重试`);
      }
    },
    handleSubmit () {
      if (!this.loginByPwd.username) {
        this.$Message.warning('请输入用户名');
        this.$refs['username'].focus();
        return;
      }
      if (!this.loginByPwd.password) {
        this.$Message.warning('请输入密码');
        this.$refs['password'].focus();
        return;
      }
      this.postLogin()
    },
    postLogin (params) {
      const _self = this;
      if (_self.loginPage === 1) {
        const temp = {
          password: _self.loginByPwd.password,
          username: _self.loginByPwd.username
        }
        if (params) {
          temp.captchaVerification = params.captchaVerification
        }
        _self.post('/sys/login', temp).then(res => {
          sessionStorage.setItem('token', res.data.token);
          // sessionStorage.setItem('menu', JSON.stringify(res.data.list));
          sessionStorage.setItem('name', res.data.user.name);
          // sessionStorage.setItem('accountType', res.data.user.accountType)
          sessionStorage.setItem('schoolName', res.data.user.schoolName);
          sessionStorage.setItem('balances', res.data.user.balances || '')

          _self.$store.commit('sessionInit');
          _self.getRole(res.data);
        }).catch((error) => {
          if (error.data) {
            _self.$refs.verify.show();
          } else {
            _self.loginByPwd.password = ''
          }
        })
      } else {
        if (!_self.loginVerify) {
          return
        }
        _self.post('/sys/SMSLogin', {
          mobile: _self.loginByPhone.phone,
          smsCode: _self.loginByPhone.code
        }).then(res => {
          sessionStorage.setItem('token', res.data.token);
          // sessionStorage.setItem('menu', JSON.stringify(res.data.list));
          sessionStorage.setItem('name', res.data.user.name);
          sessionStorage.setItem('schoolName', res.data.user.schoolName);
          sessionStorage.setItem('balances', res.data.user.balances || '')
          // sessionStorage.setItem('accountType', res.data.user.accountType)
          _self.$store.commit('sessionInit');
          _self.getRole(res.data);
        });
      }
    },
    getRole (defaultRoleMsg) {
      const _self = this;
      _self.roleList = []
      _self.roleLoaded = false
      _self.fetch('/sys/role/queryExistRoleListByUserId').then(res => {
        _self.roleLoaded = true
        if (res.data) {
          _self.roleList = res.data
          sessionStorage.setItem('roleList', JSON.stringify(_self.roleList));
          _self.$store.commit('roleListInit');
          if (defaultRoleMsg && defaultRoleMsg.role) {
            sessionStorage.setItem('menu', JSON.stringify(defaultRoleMsg.list));
            sessionStorage.setItem('role', JSON.stringify(defaultRoleMsg.role));
            _self.$store.commit('roleInit')
            if (_self.$route.query.redirect) {
              _self.$router.push({path: _self.$route.query.redirect});
            } else {
              _self.$router.push({path: '/'});
            }
          } else {
            _self.curPage = 'chooseRole';
            if (_self.roleList.length === 1) {
              _self.getRoleMenu(res.data[0].roleId, res.data[0].roleName)
            }
          }
        }
      })
    },
    getRoleMenu (id, name) {
      const _self = this;
      _self.fetch('/sys/role/chooseRole', {roleId: id}).then(res => {
        sessionStorage.setItem('menu', JSON.stringify(res.data.list));
        sessionStorage.setItem('role', JSON.stringify(res.data.role));
        _self.$store.commit('roleInit')
        if (_self.$route.query.redirect) {
          _self.$router.push({path: _self.$route.query.redirect});
        } else {
          _self.$router.push({path: '/'});
        }
      });
    },
    loginOut () {
      this.$store.commit('sessionMiss');
      this.curPage = 'login';
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>
<style lang="less" scoped>
  .login-container {
    background-color: rgba(@text-color, .75);
    .login-image-back {
      background: url('../../assets/images/login-bg3.png') no-repeat;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
      background-size: auto 100%;
    }
    .login-title {
      z-index: 1;
      width: 100%;
      height: 200px;
      margin-top: 10%;
      background-color: #2496FF;
      opacity: 0.89;
    }
    .login-title-chinese {
      display: block;
      height: 45px;
      margin-top: 65px;
      margin-left: 120px;
      font-size: 32px;
      font-weight: 500;
      color: #fff;
      letter-spacing: 5px;
    }
    .login-title-english {
      display: block;
      margin-top: 10px;
      margin-left: 120px;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
    }
    .login-icon {
      margin-top: 5%;
      margin-left: 160px;
      width: 331px;
      height: 81px;
    }
    .form-data {
      background-color: #ffffff;
      width: 450px;
      height: 446px;
      left: 75%;
      z-index: 2;
      margin-left: -230px;
      border-radius: 5px;
      box-shadow: 0 0 30px rgba(0,0,0,.1);
      padding: 50px 0 30px;
      position: fixed;
      top: 20%;
      .login-box-title {
        text-align: center;
        padding-top: 20px;
        margin-bottom: 40px;
      }
      .login-box-title>span {
        display: block;
        letter-spacing: 0.5px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
      }
      .logo-title {
        background-color: @base-color;
        position: absolute;
        top: -30px;
        height: 60px;
        line-height: 60px;
        overflow: hidden;
        width: 360px;
        text-align: center;
        border-radius: 40px;
        margin: 0 70px;
        opacity: 0.9;
        box-shadow: 0 4px 4px rgba(71,184,224,.5);
        img {
          margin-top: 5px;
        }
        span {
          color: #ffffff;
          font-size: 20px;
          display: inline-block;
          margin-left: 10px;
          vertical-align: top;
        }
      }
      .change-login {
        width: 400px;
        margin: 10px auto 20px;
        display: flex;
        justify-content: space-around;
        font-size: 14px;
        a{
          color: @text-color;
          padding: 0 10px 2px 10px;
        }
        a.on {
          color: @base-color;
          display: block;
          border-bottom: 2px solid @base-color;
          padding: 0 10px 2px 10px;
        }
      }
      label {
        color: @base-color;
        display: block;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
      }
      .change-panel {
        width: 340px;
        margin: 0 auto;
        text-align: right;
        &.box-large {
          margin: 20px auto 30px;
        }
      }
      .oper-panel {
        button {
          &.off {
            color: @input-disabled-color;
            background-color: @input-disabled-bg;
            cursor: @cursor-disabled;
          }
          width: 340px;
          font-size: 18px;
          font-weight: bold;
          color: white;
          height: 50px;
          line-height: 50px;
          text-align: center;
          margin: 20px auto;
          display: block;
          border-radius: 5px;
          cursor: pointer;
          background-color: @base-color;
          border: none;
          letter-spacing: 1px;
          overflow: hidden;
        }
      }
    }
  }
  .register {
    position: absolute;
    width: 1180px;
    bottom: 20px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    margin-left: -590px;
    color: @normal-color;
    font-size: 13px;
    a {
      color: @normal-color;
    }
  }
</style>
<style lang="less">
  .login-container {
    .form-data {
      .kh-form {
        input{
          -webkit-box-shadow: 0 0 0 1000px white inset;
        }
        width: 340px;
        margin: 0 auto 16px;
        .kh-form-item {
          .kh-form-item-content {
            .kh-input{
              font-size: 20px;
              height: 40px;
              &::-webkit-input-placeholder{
                font-size: @font-size-small;
              }    /* 使用webkit内核的浏览器 */
              &:-moz-placeholder{
                font-size: @font-size-small;
              }    /* Firefox版本4-18 */
              &::-moz-placeholder{
                font-size: @font-size-small;
              }    /* Firefox版本19+ */
              &:-ms-input-placeholder{
                font-size: @font-size-small;
              }    /* IE浏览器 */
            }
            .kh-input-group-append {
              padding: 0;
            }
          }
          .send-message {
            .kh-input{
              border-right: 0 none;
            }
            .kh-input-group-append {
              background-color: transparent;
              border-left: 0 none;
              line-height: 38px;
              padding: 0;
              width: 75px;
              span {
                cursor: pointer;
                display: block;
                &:hover {
                  color: @base-color;
                }
                &.disabled {
                  color: @input-disabled-color;
                  background-color: @input-disabled-bg;
                  &:hover {
                    color: @input-disabled-color;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/login/index.vue